<template>
  <div>
    <div class="top-info">
      <a target="_blank" :href="widgetLibraryUrl"><img src="/static/img/dummy-help.png" /><span class="abt_section">About this feature</span></a>
    </div>
    <div class="columns mt-20">
      <div class="column">
        <div class="page-title main_widget_title">Widgets</div>
        <p class="margin-top-12 page-desc widget_desc" data-track="View Onsite Widget Library page">
          Use our Widgets to build trust through social proofing. To implement our Widgets, embed our Widget code in your website or download a PNG and add Widgets into your invoices, email signatures and other marketing collateral.
        </p>
      </div>
    </div>
    <div class="widget-box-container-heading">
      <h3>Display widgets</h3>
    </div>
    <div class="widgets-list widget-box-container">
      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('carousel')"data-track="Star Rating">
          <div class="card-content-wrapper-box widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>

            <div class="logo-holder">
              <img src="/static/img/reviews/fb_logo.png">
              <img src="/static/img/reviews/google_logo.png">
            </div>
              <img class="" src="/static/img/dummy-new-carousel.png" class="margin-top-17" />

          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">Carousel</div>
            <div class="widget-desc">
              Allows users to cycle through your
              latest reviews.
            </div>
          </div>
        </div>
      </div>



      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('reviewBadge')" data-track="Review Badge">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <img class="margin-top-17" src="/static/img/dummy_review_badge.png" />
          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">Verified review badge</div>
            <div class="widget-desc">
              A badge that brings instant credibility to your reviews.
            </div>
          </div>
        </div>
      </div>

      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('verifiedSiteBadge')" data-track="Verified site Badge">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <img class="margin-top-44" src="/static/img/dummy-verified-site-badge.png" />
          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">Verified Badge</div>
            <div class="widget-desc">
              A badge indicating that you are a Hellopeter verified business.
            </div>
          </div>
        </div>
      </div>

      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('metricDisplayBadge')" data-track="Metric Display Badge">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <img class="margin-top-17" src="/static/img/dummy_metrics_display.png" />
          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">Metric display badge</div>
            <div class="widget-desc">
              A badge that displays a summary of your review metrics.
            </div>
          </div>
        </div>
      </div>

      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('reviewSlider')" data-track="Review vertical feed">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <div id="dummy-logo-holder">
              <img src="/static/img/dummy-review_slider_1.png" />
              <div class="logo-holder">
                <img src="/static/img/reviews/fb_logo.png">
                <img src="/static/img/reviews/google_logo.png"></div>
              <img class="margin-top-17" src="/static/img/dummy_review_slider_2.png" />
            </div>
          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">Review Slider</div>
            <div class="widget-desc">
              This Review Slider contains a small tab that is expandable on clicking, to reveal all your reviews.
            </div>
          </div>
        </div>
      </div>

      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('verticalFeed')" data-track="Review vertical feed">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <div id="dummy-logo-holder">
              <div class="logo-holder">
                <img src="/static/img/reviews/fb_logo.png">
                <img src="/static/img/reviews/google_logo.png"></div>
              <img class="margin-top-17" src="/static/img/dummy-vertical-feed_2.png" />
            </div>
          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">Vertical feed</div>
            <div class="widget-desc">
              Add a feed onto your website that displays your latest 4 and 5 star reviews.
            </div>
          </div>
        </div>
      </div>

      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('ribbonBadge')" data-track="Ribbon badge">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <img class="margin-top-44" src="/static/img/dummy-ribbon-badge.png" />
          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">Ribbon badge</div>
            <div class="widget-desc">
              A simple badge to show you care
about your customer’s feedback.
            </div>
          </div>
        </div>
      </div>

      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('dropDown')" data-track="Drop down Widget">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <img class="margin-top-44" src="/static/img/dummy-dropdown1.png" />
          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">Drop-down widget</div>
            <div class="widget-desc">
              A great way to display reviews without taking up much space on your site.
            </div>
          </div>
        </div>
      </div>

    </div>

    <div style="clear:both"></div>
    <div class="widget-box-container-heading mtop-20">
      <h3>Display and collect widgets</h3>
    </div>
    <div class="widgets-list widget-box-container">

      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('reviewTab')"data-track="Review Tab">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <img class="margin-top-5" src="/static/img/dummy-review-tab.png" />
          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">Review Tab</div>
            <div class="widget-desc">
              Add a floating tab to your website. Clicking the tab will display your top reviews.
            </div>
          </div>
        </div>
      </div>

      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('onSiteWriteReview')"data-track="on-site write a review">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <img class="mtop-50" src="/static/img/dummy_on_site_review.png" />
          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">On-site write A review Button</div>
            <div class="widget-desc">
              Boost your review collection by collecting reviews directly from your website.
            </div>
          </div>
        </div>
      </div>

      <div class="widget-column">
        <div class="card" :class="[isFreeSubscription ? 'non-clickable' : 'clickable']" @click="showDetails('seoPage')" data-track="seopage">
          <div class="widget-box-background ">
            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="isFreeSubscription">
              <img src="/static/img/lock-icon.svg" />
              <div class="msg">Upgrade to gain instant access</div>
            </div>
            <div id="dummy-logo-holder">
              <div class="logo-holder">
                <img src="/static/img/reviews/fb_logo.png">
                <img src="/static/img/reviews/google_logo.png"></div>
              <img class="margin-top-17" src="/static/img/dummy_seopage_widgets.png" />
            </div>

          </div>
          <div class="custom-dwonload-box box_inner_widget">
            <div class="widget-title">SEO review page</div>
            <div class="widget-desc">
              A dedicated SEO page showcasing all
              your top reviews.
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Widget Library'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Widgets Library'
      })
    },
    name: 'widgetslibrary',
    data () {
      return {
        widgetLibraryUrl: 'https://intercom.help/hellopeter/en/collections/2155411-widget-library'
      }
    },
    computed: {
      /**
       *  Return subscription name
       *  @returns {string}  subscription name
       */
      getCurrentSubscriptionName () {
        let subsDetails = JSON.parse(localStorage.getItem('billingDetails'))
        return subsDetails.subscription.name
      },
      /**
       * Check current subscription is free or not
       *
       * @returns {boolean}
       */
      isFreeSubscription () {
        return this.getCurrentSubscriptionName === 'Free'
      }
    },
    methods: {
      /**
       * Redirect to widget Details page
       * @param {string}  widgetType - widget name like trustIndex
       * @returns {void}
       */
      showDetails (widgetType) {
        if (!this.isFreeSubscription) {
          this.$router.push(this.$router.currentRoute.path + '/details/' + widgetType)
        }
      },

      /**
       *  Redirect to renew or upgrade page
       *  @returns {void}
       */
      renewOrUpgrade () {
        this.$router.push('/billing/edit-plan/g1/monthly')
      }
    }
  }
</script>

<style scoped>

.mtop-20 {
  margin-top: 37px;
}
.mtop-50 {
  margin-top: 53px;
}
.ft-11 {
  font-size: 11px !important;
  width:90% !important;
}

.margin-top-44 {
  margin-top: 44px;
}
.widget-box-container-heading {
  display: block;
  width: 100%;

}
.widget-box-container-heading h3 {
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  padding-bottom: 10px;
  border-bottom: 1px solid #dbdbdb;
}
  .margin-top-17 {
    margin-top: 17px;
  }
  .margin-top-0 {
    margin-top:0px !important;
  }
  .widget-box-container {
    margin-left: -5px;
  }
  .top-info {
    text-align: right;
    border-bottom: 1px solid #ccc;
    padding: 10px 20px 10px 0;
    cursor: pointer;
    position: absolute;
    margin: -55px -2px 0px 0px;
    right: 0;
    width: 83.5%;
  }

  .mt-20 {
    margin-top:20px;
  }
  .column {
    padding:0 0 5px 0 !important;
  }
  .top-info a {
    width: 111px;
    height: 17px;
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: normal;
    color: #58595b;
  }

  .top-info a img{
    margin-top:5px;
  }

  .top-info a span {
    margin-top: -12px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 6px;
  }

  .widget-box-background{position:relative;}
  .clickable {
    cursor: pointer;
  }

  .upgrade-popup {
    position: absolute;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.51);
    height: 100%;
    width: 100%;
    z-index: 999;
    opacity: 1;
    display: none;
    color: #ffffff;
    cursor: pointer;
  }
  .card.non-clickable .widget-box-background:hover .upgrade-popup {display:flex;justify-content:center;flex-direction: column;}
  .vertical-center {
    margin-top: 20px;
  }

  .card-header {
    background-color: #909ea9;
  }

  .card-header > p {
    color: #ffffff;
  }

  .card {
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 0 rgba(10, 10, 10, 0.1);
  }
  .widget-column {
    width: 278px;
    height: 254px;
    float: left;
    margin: 10px 5px;
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 0 rgba(10, 10, 10, 0.1);
  }

  .card-content-wrapper-box{
    width:100%;
    margin: 0 auto;
  }
  .card{border: 1px solid #8a88881a;}
  .custom-dwonload-box{
    padding: 15px;
  }
  .custom-dwonload-box h3{
    font-weight: 600;
    margin-bottom: 10px;
  }
  .custom-dwonload-box .anchor{
    display: flex;
    margin-top: 50px;
  }
  .custom-dwonload-box .anchor a{
    cursor: pointer;
    color: #58595B;
  }

  .page-title {
    width: 72px;
    height: 24px;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
  }

  .page-desc {
    width: 100%;
    height: 46px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #707070;
  }
  .widget-box-background {
    min-height: 148px;
    text-align: center;
    background-image: url('/static/img/widget_background.png');
  }
  .main_widget_title{ margin-top: 12px;}

  .widget-title {
    width: 100%;
    height: 19px;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: center;
    color: #58595b;
    margin:10px 0px
  }

  .widget-desc {
    width: 80%;
    height: 48px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.42;
    letter-spacing: normal;
    text-align: center;
    color: #8a8c91;
    margin: 0 auto;
  }

  .margin-top-12 {
    margin-top:12px;
  }
  .widget_desc{margin-top:5px;}
  .abt_section{font-size: 12px;}
  .box_inner_widget{padding:15px 14px 13px;}
  .logo-holder {
    height: 35px;
    width: 64px;
    position: absolute;
    top: 9px;
    background: #fff;
    padding: 6px 0 6px 0;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
  }

  div#dummy-logo-holder {
    position: relative;
  }

  .logo-holder img {
    width: 20px;
  }
  @media only screen and (max-width: 1024px) and (min-width: 768px) {
    .top-info {
      text-align: right;
      border-bottom: 1px solid #ccc;
      padding: 15px 20px 10px 0;
      cursor: pointer;
      position: absolute;
      margin: -63px -2px 0px 0px;
      right: 0;
      width: 95.5%;
    }
  }
  @media only screen and (max-width: 992px) and (min-width: 768px) {
    .top-info {
      width: 93.5%;
    }
  }
  @media only screen and (max-width: 767px){
    .top-info {
      width:100%;
    }
  }
  .upgrade-popup img {
    position: relative;
    top: -15px;
    height: 27px !important;
  }

  .upgrade-popup .msg {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/onsite-widgets/Badges.vue